"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathUtil = void 0;
class MathUtil {
    constructor() {
    }
    static getAge(birthdate) {
        if (birthdate === "") {
            return 0;
        }
        const [month, day, year] = birthdate.split('/').map(Number);
        const birthDateObj = new Date(year, month - 1, day);
        const today = new Date();
        let age = today.getFullYear() - birthDateObj.getFullYear();
        const hasBirthdayPassed = today.getMonth() > birthDateObj.getMonth() ||
            (today.getMonth() === birthDateObj.getMonth() && today.getDate() >= birthDateObj.getDate());
        if (!hasBirthdayPassed) {
            age--;
        }
        return age;
    }
}
exports.MathUtil = MathUtil;
